import { CONSTANTS } from '..'

export const MASTER_MANAGEMENT_CONSTANTS: any = {
  MASTERS_COLUMNS: [{ id: 'value', label: 'Name', sort: false }],

  MASTER_COLUMNS: (
    masterType: 'system_configuration' | 'segment-master' | 'widget-layout-config',
    masterObj: any,
  ) => {
    let columnHeaderValues: any[] = []
    if (masterType === 'segment-master') {
      if (masterObj === 'pack-family') {
        columnHeaderValues = [
          { id: 'countryNames', label: 'Country', sort: false },
          { id: 'key', label: 'Key', sort: true },
          { id: 'value', label: 'Value', sort: true },
          { id: 'createdBy', label: 'Created By', sort: false },
          { id: 'updatedBy', label: 'Updated By', sort: false },
          { id: 'status', label: 'Status', sort: true },
          { id: CONSTANTS.PAGE_TYPE.EDIT, label: 'Action', accessor: '_id' },
        ]
      } else if (masterObj === 'state') {
        columnHeaderValues = [
          { id: 'countryName', label: 'Country', sort: false },
          { id: 'key', label: 'Key', sort: true },
          { id: 'value', label: 'Value', sort: true },
          { id: 'createdBy', label: 'Created By', sort: false },
          { id: 'updatedBy', label: 'Updated By', sort: false },
          { id: 'status', label: 'Status', sort: true },
          { id: CONSTANTS.PAGE_TYPE.EDIT, label: 'Action', accessor: '_id' },
        ]
      } else if (masterObj === 'pack-name') {
        columnHeaderValues = [
          { id: 'packFamilyName', label: 'Pack Family', sort: false },
          { id: 'key', label: 'Key', sort: true },
          { id: 'value', label: 'Value', sort: true },
          { id: 'createdBy', label: 'Created By', sort: false },
          { id: 'updatedBy', label: 'Updated By', sort: false },
          { id: 'status', label: 'Status', sort: true },
          { id: CONSTANTS.PAGE_TYPE.EDIT, label: 'Action', accessor: '_id' },
        ]
      } else if (masterObj === 'iris-segment') {
        columnHeaderValues = [
          { id: 'key', label: 'Key', sort: true },
          { id: 'value', label: 'Value', sort: true },
          { id: 'createdBy', label: 'Created By', sort: false },
          { id: 'updatedBy', label: 'Updated By', sort: false },
          { id: 'status', label: 'Status', sort: true },
          { id: CONSTANTS.PAGE_TYPE.EDIT, label: 'Action', accessor: '_id' },
          { id: 'associatedSegments', label: 'Associated Segments', sort: false },
        ]
      } else {
        columnHeaderValues = [
          { id: 'key', label: 'Key', sort: true },
          { id: 'value', label: 'Value', sort: true },
          { id: 'createdBy', label: 'Created By', sort: false },
          { id: 'updatedBy', label: 'Updated By', sort: false },
          { id: 'status', label: 'Status', sort: true },
          { id: CONSTANTS.PAGE_TYPE.EDIT, label: 'Action', accessor: '_id' },
        ]
      }
    } else if (masterType === 'system_configuration') {
      columnHeaderValues = [
        { id: 'key', label: 'Key', sort: true },
        { id: 'value', label: 'Value', sort: false },
        { id: CONSTANTS.PAGE_TYPE.EDIT, label: 'Action', accessor: '_id' },
      ]
    } else if (masterType === 'widget-layout-config') {
      columnHeaderValues = [
        { id: 'type', label: 'Type', sort: true },
        { id: 'layout', label: 'Layout', sort: true },
        { id: 'createdBy', label: 'Created By', sort: false },
        { id: 'updatedBy', label: 'Updated By', sort: false },
        { id: 'status', label: 'Status', sort: true },
        { id: CONSTANTS.PAGE_TYPE.EDIT, label: 'Action', accessor: '_id' },
      ]
    }
    return columnHeaderValues
  },

  COUNTRIES: {
    countriesListColumn: [
      { id: 'key', label: 'Key', sort: true },
      { id: 'value', label: 'Value', sort: true },
      { id: 'createdBy', label: 'Created By', sort: true },
      { id: 'updatedBy', label: 'Updated By', sort: true },
      { id: 'status', label: 'Status', sort: true },
      { id: CONSTANTS.PAGE_TYPE.EDIT, label: 'Action', accessor: '_id' },
    ],
  },
}

export const PAGINATION_OPTION = [
  { value: 10, label: 10 },
  { value: 20, label: 20 },
  { value: 50, label: 50 },
]

export const SINGLE_SELECT_BOOLEAN_OPTION = [
  { key: 'True', value: 'True' },
  { key: 'False', value: 'False' },
]
